/**
 * URL do BFF Node (estado dos servidores).
 *
 * - Vercel + Railway (recomendado): REACT_APP_BFF_URL vazio → pedidos a /api/* na mesma origem;
 *   na Vercel defines BFF_UPSTREAM_URL (Runtime) com o URL público https do Railway — proxy serverless em api/*.
 * - Browser direto ao BFF: REACT_APP_BFF_URL = URL do Railway; CORS no Railway com o domínio do site.
 * - Local: vazio + proxy do CRA (package.json) → 127.0.0.1:3002.
 */
export function getBffBaseUrl() {
    const u = (process.env.REACT_APP_BFF_URL || "").trim().replace(/\/$/, "");
    return u || "";
}

/** URL absoluta ou relativa para GET /api/servers/status */
export function serversStatusUrl() {
    const base = getBffBaseUrl();
    return base ? `${base}/api/servers/status` : "/api/servers/status";
}
